import { render, staticRenderFns } from "./InfosPremium.vue?vue&type=template&id=68d24d04&scoped=true&"
import script from "./InfosPremium.vue?vue&type=script&lang=js&"
export * from "./InfosPremium.vue?vue&type=script&lang=js&"
import style0 from "./InfosPremium.vue?vue&type=style&index=0&id=68d24d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d24d04",
  null
  
)

export default component.exports